@if (showIcon) {
  <svg-icon
    [src]="icon | icon"
    [applyClass]="true"
    class="mb-4 flex h-20 w-20 items-center justify-center text-theme-900/20"
  ></svg-icon>
}

@if (title) {
  <h3 class="mb-1 text-sm font-semibold uppercase tracking-widest text-theme-900/40">{{ title }}</h3>
}

@if (description) {
  <p class="max-w-md text-center text-xs font-extralight text-theme-600/30">{{ description | translate }}</p>
}

<div class="mt-1 text-center text-xs font-extralight text-theme-900/30">
  <ng-content></ng-content>
</div>
